<template>
  <div>
  <Navbar />
  <router-view />
  <FooterPart />
  <cookie-consent></cookie-consent>
  
</div>
</template>

<script>

import CookieConsent from './components/CookieConsent.vue';
import FooterPart from './components/Footer.vue';
import Navbar from './components/Navbar.vue';
export default {
  name: 'App',
  components: {
    FooterPart,
    CookieConsent,
    Navbar
  }
}
</script>

<style>

</style>
